/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: BI Dashboard
 *| (C) Copyright IBM Corp. 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

define([
	'underscore',
	'../../../lib/@waca/core-client/js/core-client/ui/core/Class',
	'../../../lib/@waca/upgrades/UpgradeBase',
	'./TextWidgetTypesUpgradeHelper',
	'./WidgetTitleUpgradeHelper'
], function (_, Class, UpgradeBase, TextWidgetTypesUpgradeHelper, WidgetTitleUpgradeHelper) {

	/**
	* Upgrade pre Endor R7 text widget classes to keep its old default font family
	**/

	const Upgrade = Class.extend([UpgradeBase], {
		init: function () {
			this.VERSION = 1804;
			this.textWidgetTypesUpgradeHelper = new TextWidgetTypesUpgradeHelper();
			this.widgetTitleUpgradeHelper = new WidgetTitleUpgradeHelper();
		},

		/**
		 * Perform upgrade
		 *
		 * @param {object} spec - spec to perform upgrade on
		 *
		 * @return {Promise} Promise to be resolved when upgrade performed
		 */
		up: function (spec) {
			return this.textWidgetTypesUpgradeHelper.upgrade(spec).then((spec) => {
				return this.widgetTitleUpgradeHelper.upgrade(spec);
			});
		},

		down: function (spec) {
			// no downgrade at this time; return as is
			return Promise.resolve(spec);
		}

	});

	return new Upgrade();
});
